const defaultProject = {};

export default defaultProject;
